import type { User } from '../../../utils/loginUtils'
import { updateStorageItem, type tupper } from '../../../utils/storageUtils'
import { getMessage } from '../../../utils/messageUtils'
import { useState } from 'react'
import StoragePopupContent from './StoragePopupContent'
import Popup from '../../PopupForm/Popup'
import './TupperList.scss'

interface TupperListProps {
  user: User
  tuppers: tupper[] | undefined
  isMobile: boolean
  reloadData: () => void
  openPopup: (message: string, children: React.ReactNode) => void
  closePopup: () => void
  setPopupOnOk: React.Dispatch<React.SetStateAction<() => void>>
  setIsLoading: (isLoading: boolean) => void
}

function TupperList({
  user,
  tuppers,
  isMobile,
  reloadData,
  openPopup,
  closePopup,
  setPopupOnOk,
  setIsLoading,
}: TupperListProps) {
  const [errorMessage, setErrorMessage] = useState('')
  const [errorPopupOpen, setErrorPopupOpen] = useState(false)

  function generateTupperList() {
    if (!tuppers) return null

    const deleteStorageTupper = async (tupper: tupper | undefined) => {
      let newTupper: tupper | undefined = undefined
      if (tupper) {
        newTupper = { ...tupper, quantity: 0 }
      }
      setIsLoading(true)
      try {
        const result = (await updateStorageItem(
          user.id!,
          undefined,
          newTupper
        )) as {
          success: boolean
          error?: string
        }
        if (!result.success) {
          setErrorMessage(getMessage('save_error') + (result.error || ''))
          setErrorPopupOpen(true)
        } else {
          reloadData()
        }
      } finally {
        setIsLoading(false)
      }
    }

    return tuppers.map((tupper: tupper) => {
      return (
        <div
          key={tupper.id}
          className={`list-entry ${isMobile ? 'list-entry-mobile' : ''} tupper-entry`}
          onClick={() => {
            openPopup(
              tupper.recipe_name || '',
              <StoragePopupContent
                user={user}
                tupper={tupper}
                isMobile={isMobile}
                setOnOk={setPopupOnOk}
                reLoadData={reloadData}
                closePopup={closePopup}
                setIsLoading={setIsLoading}
              />
            )
          }}
        >
          <div className="tupper-name">
            <span>{tupper.recipe_name}</span>
          </div>
          <div className="tupper-qty">
            <span>{tupper.quantity}</span>
          </div>
          <div
            className="tupper-delete"
            onClick={e => {
              e.stopPropagation()
              deleteStorageTupper(tupper)
            }}
          >
            <span>×</span>
          </div>
        </div>
      )
    })
  }

  if (!tuppers || tuppers.length === 0) {
    return null
  }

  return (
    <div className="product-list-body-container">
      {generateTupperList()}
      <Popup
        isOpen={errorPopupOpen}
        message={errorMessage}
        isMobile={isMobile}
        onOk={undefined}
        onClose={() => setErrorPopupOpen(false)}
        hideCancelButton={true}
      />
    </div>
  )
}

export default TupperList
